import { IdmeAuthService } from 'common/api';
import { getRefreshToken } from 'utils/auth';

type RefreshTokenResponse = {
  refresh_token: string;
  id_token: string;
};

export async function refreshIdmeAccessTokenAPI(): Promise<RefreshTokenResponse> {
  return IdmeAuthService.idmeAuthControllerExchangeRefreshForBearerToken({
    refreshToken: getRefreshToken() || '',
  });
}
